// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { ArticleVO } from '@article/model/vo/article.vo';
import { OBJRepresentationDataVO } from '@shared/vo/representation.vo';

@JsonObject('ExportArticleDTO')
export class ExportArticleDTO {

  @JsonProperty('model', 'ArticleVO')
  public model: ArticleVO = undefined;

  @JsonProperty('data', 'OBJRepresentationDataVO')
  public data: OBJRepresentationDataVO = undefined;


  public static create(
    model: ArticleVO,
    data: OBJRepresentationDataVO): ExportArticleDTO {
    const dto: ExportArticleDTO = new ExportArticleDTO();
    dto.model = model;
    dto.data = data;
    return dto;
  }
}
